module.exports = "/fast-coin/img/coin/anim/in/coin_in_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_005.png
// module id = 2275
// module chunks = 5